<template functional>
  <div
    v-tooltip.bottom="
      `Ejemplo: ${
        props.row.data_formate === 'Entero'
          ? `0, 1, 2, ..., 100, ...`
          : `0.5, 1.2, ..., 10.56, ....`
      }`
    "
  >
    {{ props.row.data_formate }}
  </div>
</template>
<script>
export default {
  name: 'UnitFormatter',
};
</script>
